import initVimeoPlayers from '../components/vimeoPlayer';

initVimeoPlayers();
